module.exports = __webpack_public_path__ + "static/fonts/Roboto100italic.2cbc2256.ttf";